// Brand: identity, contact, social, quick links, hero art
export const BRAND = {
  name: "Lenslopers",
  fullName: "Lenslopers Fotografie",
  tagline: "Puur. Echt. Tijdloos.",
  photographer: "Eric",
  logo: "/brand/logo-light.png",
  logoMark: "/brand/logo-mark-light.png",
  logoDark: "/brand/logo-dark.png",
  phone: "+32495610596",
  phoneDisplay: "0495610596",
  whatsapp: "32495610596",
  email: "lenslopers@mail.com",
  address: "Marktplein 29, 9130 Kieldrecht",
  addressPostal: "Marktplein 29, 9130 Beveren-Kruibeke-Zwijndrecht, België",
  addressShort: "Kieldrecht (Beveren) — België",
  addressLocality: "Beveren-Kruibeke-Zwijndrecht",
  addressStreet: "Marktplein 29",
  postalCode: "9130",
  addressCountry: "BE",
  latitude: 51.2782,
  longitude: 4.1622,
  placeId: "ChIJN9rH5w51xEcRf7oyq4qvDU4",
  // Bankgegevens — NIET publiek tonen op de site.
  // Wordt enkel toegevoegd aan bestel-emails (bv. Vrij werk mailto-body)
  // en aan de interne bevestiging bij Cadeaubon-succes.
  iban: "BE94 6528 4527 0614",
  ibanCompact: "BE94652845270614",
  serviceRadiusKm: 10,
  serviceAreaTitle: "Actief in jouw regio!",
  freeTravelText: "Gratis verplaatsing tot 10 km",
  openingHours: [
    { day: "Ma – Zo", hours: "Op afspraak" },
  ],
  social: {
    instagram: "https://instagram.com/lenslopers",
    facebook: "https://facebook.com/lenslopers",
    pinterest: "https://pinterest.com/lenslopers",
  },
  googleReviewUrl: "https://g.page/r/CX-6MquKrw1OEAE/review",
  googleProfileUrl: "https://g.page/r/CX-6MquKrw1OEAE",
  googleRating: 5.0,
  googleReviewCount: 0,
};

export const waLink = (msg = "Hallo Eric, ik wil graag een fotoshoot boeken.") =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(msg)}`;

export const mailtoLink = (subject = "Aanvraag fotoshoot", body = "") => {
  const bankLine = `\n\n— Voor betaling via overschrijving: ${BRAND.iban} (Lenslopers Fotografie).`;
  const fullBody = body ? body + bankLine : bankLine;
  return `mailto:${BRAND.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(fullBody)}`;
};

export const telLink = `tel:${BRAND.phone.replace(/\s/g, "")}`;

export const HERO_IMAGE =
  "https://images.pexels.com/photos/8568400/pexels-photo-8568400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=2000";

export const ABOUT_ERIC_IMAGE =
  "https://customer-assets.emergentagent.com/job_capture-memories-11/artifacts/eb687nq7_657444453_10241107896815338_8257455994779838530_n.jpg";
